import styles from './StringIdHeaderComponent.module.scss';

/**
 * Custom header component for String ID column in the data grid.
 * Displays the column name with an info icon.
 */
export class StringIdHeaderComponent {
  private eGui!: HTMLDivElement;

  init(params: any) {
    this.eGui = document.createElement('div');
    this.eGui.className = styles.container;

    // Display column name
    const text = document.createElement('span');
    text.textContent = params.displayName;
    this.eGui.appendChild(text);

    // Popover trigger wrapper for hover interaction
    const iconWrapper = document.createElement('kat-popover-trigger');
    iconWrapper.setAttribute('for', 'string-id-header-popover');
    iconWrapper.setAttribute('type', 'hover');

    // Info icon to display additional information on hover
    const icon = document.createElement('kat-icon');
    icon.setAttribute('name', 'info-circle');
    icon.setAttribute('size', 'tiny');

    iconWrapper.appendChild(icon);
    this.eGui.appendChild(iconWrapper);
  }

  getGui() {
    return this.eGui;
  }
}
